import classes from './inbound-notifications-panel.module.scss'

type Props = {
  count: number
}

export function InboundNotificationsBadge({ count }: Props) {
  if (count <= 0) {
    return null
  }
  return <span className={classes.dot} />
}
